module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(_vm.data !== false) ? _c('mu-card-text', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "40",
      "desktop": "40",
      "tablet": "40"
    }
  }, [_c('div', {
    staticClass: "blueText cardTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiary' + _vm.type.charAt(0).toUpperCase() + _vm.type.slice(1))) + "\n          ")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "60",
      "desktop": "60",
      "tablet": "60",
      "align": "right"
    }
  }, [(_vm.data) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Favourite'),
      expression: "'Favourite'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "iconClass": "redIcon",
      "icon": _vm.data.userFavorites ? 'favorite' : 'favorite_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorite(_vm.data.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('View breakdown'),
      expression: "'View breakdown'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "bar_chart"
    },
    nativeOn: {
      "click": function($event) {
        _vm.isGraphShown = !_vm.isGraphShown
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Refresh'),
      expression: "'Refresh'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "refresh"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refresh.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('View recipe'),
      expression: "'View recipe'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo(_vm.data.id)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [(_vm.data) ? _c('mu-col', {
    staticClass: "recipeBg",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    style: ({
      'background': 'url(' + _vm.data.photoSmallUri + ')'
    }),
    attrs: {
      "width": "30",
      "tablet": "25",
      "desktop": "25"
    }
  }, [(_vm.isLoading) ? _c('mu-circular-progress', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    },
    attrs: {
      "color": "white"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('div', {
    staticClass: "blueText",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.data.title) + "\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.servings) + " serving(s) · Carbs " + _vm._s(_vm.oneCarbPortion.toFixed(0)) + "g (1 serving)\n          ")])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.data === false) ? _c('mu-card-text', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "blueText cardTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiary' + _vm.type.charAt(0).toUpperCase() + _vm.type.slice(1))) + "\n          ")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "iconClass": "redIcon",
      "icon": 'favorite_outline'
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "icon": "bar_chart"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "icon": "refresh"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "recipeBg",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    style: ({
      'background': 'url(static/recipe-placeholder.png)'
    }),
    attrs: {
      "width": "30",
      "tablet": "25",
      "desktop": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('div', {
    staticClass: "blueText",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('mu-linear-progress', {
    staticStyle: {
      "width": "50%",
      "height": "14px",
      "background": "rgb(214, 214, 214)",
      "margin-bottom": "8px"
    },
    style: ({
      width: _vm.getRandomArbitrary(40, 90)
    }),
    attrs: {
      "slot": "describe",
      "color": "#d9d9d9"
    },
    slot: "describe"
  })], 1), _vm._v(" "), _c('div', [_c('mu-linear-progress', {
    staticStyle: {
      "width": "50%",
      "height": "14px",
      "background": "rgb(214, 214, 214)",
      "margin-bottom": "8px"
    },
    style: ({
      width: _vm.getRandomArbitrary(40, 50)
    }),
    attrs: {
      "slot": "describe",
      "color": "#d9d9d9"
    },
    slot: "describe"
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data && _vm.isGraphShown) ? _c('mu-card-text', {
    staticClass: "bubble-progress"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden",
      "white-space": "nowrap",
      "font-size": "0",
      "-webkit-border-radius": "8px",
      "-moz-border-radius": "8px",
      "border-radius": "8px",
      "margin-bottom": "16px"
    }
  }, [_c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.fat + '%',
      'background': 'rgb(192, 77, 216)'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.carbs + '%',
      'background': 'rgb(78, 216, 218)'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.protein + '%',
      'background': 'rgb(224, 105, 80)'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(192, 77, 216)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientFat')) + ": " + _vm._s(_vm.oneFatPortion.toFixed(0) + 'g') + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(78, 216, 218)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + ": " + _vm._s(_vm.oneCarbPortion.toFixed(0) + 'g'))]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(224, 105, 80)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientProtein')) + ": " + _vm._s(_vm.oneProteinPortion.toFixed(0) + 'g'))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbfac66a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/MealPlanGenerator/components/meal-plan-panel.vue
// module id = 3832
// module chunks = 1